import { render, staticRenderFns } from "./FormProSetting.vue?vue&type=template&id=6056df3e&scoped=true"
import script from "./FormProSetting.vue?vue&type=script&lang=js"
export * from "./FormProSetting.vue?vue&type=script&lang=js"
import style0 from "./FormProSetting.vue?vue&type=style&index=0&id=6056df3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056df3e",
  null
  
)

export default component.exports